import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import MissionPage from "@/pages/MissionPage";
import ResultsPage from "@/pages/ResultsPage";
import ResourcesPage from "@/pages/ResourcesPage";
import BookCallPage from "@/pages/BookCallPage";

function App() {
  return (
    <BrowserRouter>
      <div className="noise-overlay" aria-hidden="true" />
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/mission" element={<MissionPage />} />
          <Route path="/results" element={<ResultsPage />} />
          <Route path="/resources" element={<ResourcesPage />} />
          <Route path="/book-a-call" element={<BookCallPage />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
